// components/shared/Loading.js
// מצב טעינה — spinner + הודעה
// שימוש:
//   <Loading />                           — spinner inline
//   <Loading fullPage />                   — spinner ממרכז את כל המסך
//   <Loading message="טוען נתונים..." />  — spinner עם הודעה

import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function Loading({ fullPage = false, message = null, size = 40 }) {
  const { t } = useTranslation();
  const displayMessage = message || t('common.loading');

  if (fullPage) {
    return (
      <Box
        data-testid="shared__loading--full-page"
        role="status"
        aria-label={displayMessage}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 2,
        }}
      >
        <CircularProgress size={size} />
        <Typography variant="body2" color="text.secondary">
          {displayMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      data-testid="shared__loading--inline"
      role="status"
      aria-label={displayMessage}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        py: 3,
      }}
    >
      <CircularProgress size={size} />
      {message && (
        <Typography variant="body2" color="text.secondary">
          {displayMessage}
        </Typography>
      )}
    </Box>
  );
}
